module.exports = __webpack_public_path__ + "static/img/Sydney-Swans.fb52021.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sydney-Swans.jpg
// module id = 9hh6
// module chunks = 1